import thunkMiddleware from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import * as reducers from './reducers';
import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';

import crashReporter from '../../researcher/blocks/error-boundary/crash-reporter';
import { hydrateOrganizationFromShell } from '../../researcher/redux/organizations/hydrate.organizations';

const middleware = [thunkMiddleware, crashReporter];

export const configureStore = () => {
  const store = createStore(
    combineReducers({
      ...reducers,
    }),
    composeWithDevTools(applyMiddleware(...middleware)),
  );
  hydrateOrganizationFromShell(store);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextReducers = require('./reducers'); // eslint-disable-line
      store.replaceReducer(
        combineReducers({
          ...nextReducers,
        }),
      );
    });
  }

  return store;
};

export { actions, constants, selectors };
